import React from 'react';

// This fixed space prevents elements from moving when an error message is displayed.
export const ErrorWrapper = ({ minHeight, children }) => (
  <div style={{ minHeight: `${minHeight}px` }}>
    {children}
  </div>
);
